// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__slQpb","subheader":"ReorderModal_subheader__26vgc","listWrap":"ReorderModal_listWrap__1jSv3"};